import React from 'react';
import './ndoeUi.css';

/**
 * NdoePageHeader — en-tête premium : eyebrow + titre serif + sous-titre + actions.
 *
 * Props :
 *  - eyebrow   : sur-titre or en majuscules (optionnel)
 *  - title     : titre principal (string ou node)
 *  - subtitle  : sous-titre muted (optionnel)
 *  - actions   : node(s) à droite (boutons) — sur mobile, passe sous le titre
 *  - className
 */
export default function NdoePageHeader({ eyebrow, title, subtitle, actions, className = '' }) {
  return (
    <header className={`ndoe-page-header ${className}`}>
      <div className="ndoe-page-header__titles">
        {eyebrow ? <div className="ndoe-eyebrow">{eyebrow}</div> : null}
        {title ? <h1 className="ndoe-page-title">{title}</h1> : null}
        {subtitle ? <p className="ndoe-page-subtitle">{subtitle}</p> : null}
      </div>
      {actions ? <div className="ndoe-page-header__actions">{actions}</div> : null}
    </header>
  );
}
